export default __webpack_public_path__ + "static/media/image3pro4.eddf0379.jpeg";